var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicHex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.52686,
    y: 69.5967,
    width: 19.6227,
    height: 6.52728,
    rx: 3.26364,
    fill: "#3C1717"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40.0693,
    y: 69.5967,
    width: 19.6227,
    height: 6.52728,
    rx: 3.26364,
    fill: "#3C1717"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.38051 38.1117C1.25638 36.128 1.25639 33.6998 2.38051 31.7161L15.6751 8.25602C16.8267 6.22379 18.9822 4.96779 21.318 4.96779H47.6993C50.0351 4.96779 52.1906 6.22379 53.3422 8.25602L66.6368 31.7161C67.7609 33.6998 67.7609 36.128 66.6368 38.1117L53.3422 61.5718C52.1906 63.604 50.0351 64.86 47.6993 64.86H21.318C18.9822 64.86 16.8267 63.604 15.6751 61.5718L2.38051 38.1117Z",
    fill: "#3C1717"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5131 42.6536C42.0627 42.6536 48.1829 36.4104 48.1829 28.7091C48.1829 21.0078 42.0627 14.7646 34.5131 14.7646C26.9634 14.7646 20.8433 21.0078 20.8433 28.7091C20.8433 36.4104 26.9634 42.6536 34.5131 42.6536Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4724 34.8322C35.259 34.8322 38.3286 31.7398 38.3286 27.9251C38.3286 24.1105 35.259 21.0181 31.4724 21.0181C27.6858 21.0181 24.6162 24.1105 24.6162 27.9251C24.6162 31.7398 27.6858 34.8322 31.4724 34.8322Z",
    fill: "#570029"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0798 33.2227V45.5478C56.0798 49.6304 59.3055 52.9428 63.2813 52.9428C67.2571 52.9428 70.4827 49.6304 70.4827 45.5478H64.4815C63.8214 45.5478 63.2813 44.9931 63.2813 44.3153C63.2813 43.6374 63.8214 43.0827 64.4815 43.0827H70.4827V40.6177H64.4815C63.8214 40.6177 63.2813 40.0631 63.2813 39.3852C63.2813 38.7073 63.8214 38.1527 64.4815 38.1527H70.4827V35.6877H64.4815C63.8214 35.6877 63.2813 35.1331 63.2813 34.4552C63.2813 33.7773 63.8214 33.2227 64.4815 33.2227H70.4827C70.4827 29.14 67.2571 25.8276 63.2813 25.8276C59.3055 25.8276 56.0798 29.14 56.0798 33.2227ZM72.8832 44.3153V45.5478C72.8832 50.9939 68.5849 55.4078 63.2813 55.4078C57.9777 55.4078 53.6793 50.9939 53.6793 45.5478V42.4665C53.6793 41.442 52.8767 40.6177 51.879 40.6177C50.8813 40.6177 50.0786 41.442 50.0786 42.4665V45.5478C50.0786 52.4113 55.0446 58.0808 61.4809 58.9821V61.5704H57.8802C56.8825 61.5704 56.0798 62.3946 56.0798 63.4191C56.0798 64.4436 56.8825 65.2679 57.8802 65.2679H68.6824C69.6801 65.2679 70.4827 64.4436 70.4827 63.4191C70.4827 62.3946 69.6801 61.5704 68.6824 61.5704H65.0816V58.9821C71.5179 58.0808 76.4839 52.4113 76.4839 45.5478V42.4665C76.4839 41.442 75.6813 40.6177 74.6836 40.6177C73.6859 40.6177 72.8832 41.442 72.8832 42.4665V44.3153Z",
    fill: "#F9858E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4815 35.6877H70.4827V33.2227H64.4815C63.8214 33.2227 63.2813 33.7773 63.2813 34.4552C63.2813 35.1331 63.8214 35.6877 64.4815 35.6877Z",
    fill: "#FFEEED"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4815 40.6177H70.4827V38.1527H64.4815C63.8214 38.1527 63.2813 38.7073 63.2813 39.3852C63.2813 40.0631 63.8214 40.6177 64.4815 40.6177Z",
    fill: "#FFEEED"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4815 45.5478H70.4827V43.0827H64.4815C63.8214 43.0827 63.2813 43.6374 63.2813 44.3153C63.2813 44.9931 63.8214 45.5478 64.4815 45.5478Z",
    fill: "#FFEEED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicHex);
export default __webpack_public_path__ + "static/media/mic-hex.af5058d1ceb5404247062b896f91f17b.svg";
export { ForwardRef as ReactComponent };